import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';

const TimeBar = ({ handleBack, handleForward, handleRefresh, generateTimeSlots, windowStartTime, windowEndTime }) => {
    const [currentTime, setCurrentTime] = useState(new Date());

    // This ensures that the time updates every second
    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000); // Update every second

        return () => clearInterval(intervalId);
    }, []);

    // Format the current date and time
    const formatCurrentTime = (date) => {
        return date.toLocaleString('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
        });
    };

    const timeSlots = generateTimeSlots(windowStartTime, windowEndTime).map(time => new Date(time).getTime());
    const slotWidthPercent = 100 / (timeSlots.length - 1); // Adjust the width by subtracting 1 to exclude the last slot

    return (
        <Box sx={{ position: 'relative', display: 'flex', backgroundColor: '#333', padding: '8px', width: '100%', zIndex: 3 }}>
            {/* Date and time on the left */}
            <Box sx={{ width: '250px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography color="white" fontSize="12px" fontWeight={600} pl={1}>
                    {formatCurrentTime(currentTime)}
                </Typography>
            </Box>

            {/* Time slots */}
            <Box sx={{ flexGrow: 1, display: 'flex', overflowX: 'auto', position: 'relative' }}>
                {timeSlots.slice(0, -1).map((time, index) => (
                    <Box
                        key={index}
                        sx={{
                            flex: '1 1 auto',
                            padding: '8px',
                            borderRight: '1px solid #444',
                            textAlign: 'left',
                            whiteSpace: 'nowrap',
                            minWidth: `${slotWidthPercent}%`, // Ensure all time slots have the same width based on percentage
                        }}
                    >
                        <Typography color="white" fontSize="10px">
                            {new Date(time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default TimeBar;
